import * as React from "react";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  CssBaseline,
  Divider,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Snackbar,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { useTheme } from "@mui/material/styles";
import { routeModules } from "../config/routeconfig";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useNavigate } from "react-router-dom";
import LockIcon from "@mui/icons-material/Lock";
import LogoutIcon from "@mui/icons-material/Logout";
import packageJson from "../../package.json";
import Loading from "../common/Laoding";
import { useEffect } from "react";
import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

import pettycash from "../assets/cashflow.png";
import fuelmanagement from "../assets/fuel.png";
import Viewbookings from "../assets/view.png";
import peakseasonicon from "../assets/peakseason.png";
import reports from "../assets/reports.png";
import bookingdashboard from "../assets/bookingdashboard.png";
import vehiclerevenue from "../assets/vehiclerevenue.png";
import fleet from "../assets/fleet.png";
import partnerwithus from "../assets/partner.png";
import subscription from "../assets/subscription.png";
import fleetsdashboard from "../assets/fleet-supervisor.png";
import vehiclesdashboard from "../assets/vehicledashboard.png";
import issuesdashboard from "../assets/issues.png";
import feedbacks from "../assets/feedback.png";
import support from "../assets/support.png";
import workorders from "../assets/tasking.png";
import accounting from "../assets/accounting.png";
import recoveryPending from "../assets/recovery.png";
import kyv from "../assets/kyv.png";
import fleetoperations from "../assets/fleetoperations.png";
import clutchnotification from "../assets/clutchreminder.png";
import Vehiclegroupsales from "../assets/Vehiclegroupsales.png";
import bookinganalytics from "../assets/bookinganalysis.png";
import fleetutilization from "../assets/fleet-utilization.png";
import pettycashdistribution from "../assets/pettycashdistribution.png";
import wheelalignment from "../assets/wheelalignment.png";
import documentIcon from "../assets/document.png";
import emi from "../assets/interest-rate.png";
import UseOnlineStatus from "../common/UseOnlineStatus";
import NoInternet from "../common/NoInternet";

const drawerWidth = 330;

const Layout = ({ module, activeItem, setActiveItem }) => {
  const navigate = useNavigate();
  const { isOnline, isSlowConnection } = UseOnlineStatus();
  const profile = JSON.parse(localStorage.getItem("profile"));
  const navItems = routeModules[module]?.sidebar || [];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [filteredModules, setFilteredModules] = React.useState([]);
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const actions = JSON.parse(localStorage.getItem("catalogValues"))?.action;
  const rolesFromResponse = profile?.roles;
  const rolesFromCatalogValues = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.role?.inverted;
  const actionFromResponse = profile?.actions || [];
  const [openQuickLinks, setOpenQuickLinks] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const isProfileMenuOpen = Boolean(anchorEl);

  const handleProfileMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("profile");
    localStorage.removeItem("token");
    localStorage.removeItem("rememberedEmail");
    localStorage.removeItem("status");
    localStorage.removeItem("catalogMaster");
    localStorage.removeItem("catalogValues");
    setTimeout(() => window.location.reload(), 700);
    navigate("/");
  };

  const { vertical, horizontal, open } = state;

  const handleClick = (newState) => () => {
    setState({ ...newState, open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const moduleCardConfig = {
    // ===== SALES CATEGORY (6) =====
    "Vehicle Revenue Dashboard": {
      title: "Vehicle Revenue",
      image: vehiclerevenue,
      route: "/vehiclerevenue",
      value: "vehiclerevenue",
      category: "fleet",
      description: "Track vehicle revenue performance",
    },
    "View Reports Dashboard": {
      title: "Reports",
      image: reports,
      route: "/reports",
      value: "reports",
      category: "others",
      description: "Generate and view reports",
    },
    "View Sales Agent Dashboard": {
      title: "Sales Agent Dashboard",
      image: support,
      route: "/salesagentdashboard",
      value: "salesagentdashboard",
      category: "sales",
      description: "Sales agent performance metrics",
    },
    "View Segmented Sales Dashboard": {
      title: "Segmented Sales",
      image: Vehiclegroupsales,
      route: "/segmentedsales",
      value: "segmentedsales",
      category: "sales",
      description: "Segmented sales analysis",
    },
    "View Recovery Dashboard": {
      title: "Recovery Pending",
      image: recoveryPending,
      route: "/recoverypending",
      value: "recoverypending",
      category: "backend",
      description: "Track pending recoveries",
    },
    "View Booking Ledger Dashboard": {
      title: "Booking Ledger",
      image: accounting,
      route: "/bookingledger",
      value: "bookingledger",
      category: "accounts",
      description: "Booking financial records",
    },

    // ===== FLEET CATEGORY (8) =====
    "Fleet Dashboard": {
      title: "Fleet Dashboard",
      image: fleet,
      route: "/fleetdashboard",
      value: "fleetdashboard",
      category: "fleet",
      description: "Comprehensive fleet overview",
    },
    "View All Vehicles": {
      title: "Vehicles Dashboard",
      image: vehiclesdashboard,
      route: "/vehiclesdashboard",
      value: "vehiclesdashboard",
      category: "fleet",
      description: "Complete vehicle management",
    },
    "View Fleet Operation Dashboard": {
      title: "Fleet Operations",
      image: fleetoperations,
      route: "/fleetoperation",
      value: "fleetoperation",
      category: "fleet",
      description: "Fleet operational analytics",
    },
    "Get Vehicle Details": {
      title: "Know Your Vehicle",
      image: kyv,
      route: "/knowyourvehicle",
      value: "knowyourvehicle",
      category: "fleet",
      description: "Vehicle information and details",
    },
    "Fleet Utilization": {
      title: "Fleet Utilization",
      image: fleetutilization,
      route: "/fleetutilization",
      value: "fleetutilization",
      category: "fleet",
      description: "Fleet utilization metrics",
    },
    "Vehicle EMI Dashboard": {
      title: "Vehicle EMI Dashboard",
      image: emi,
      route: "/vehicleemidashboard",
      value: "vehicleemidashboard",
      category: "fleet",
      description: "Vehicle EMI tracking",
    },
    "Vehicle Document Dashboard": {
      title: "Vehicle Document Dashboard",
      image: documentIcon,
      route: "/vehicledocumentdashboard",
      value: "vehicledocumentdashboard",
      category: "fleet",
      description: "Vehicle document management",
    },
    "View Clutch Notification Dashboard": {
      title: "Clutch Notifications",
      image: clutchnotification,
      route: "/clutchnotification",
      value: "clutchnotification",
      category: "fleet",
      description: "Clutch notification management",
    },

    // ===== BOOKING CATEGORY (5) =====
    "View All Booking": {
      title: "View Bookings",
      image: Viewbookings,
      route: "/viewallbookings",
      value: "viewallbookings",
      category: "booking",
      description: "View and manage all bookings",
    },
    "Booking Dashboard": {
      title: "Booking Dashboard",
      image: bookingdashboard,
      route: "/bookingdashboard",
      value: "bookingdashboard",
      category: "booking",
      description: "Real-time booking analytics",
    },
    "Booking Analytics": {
      title: "Booking Analytics",
      image: bookinganalytics,
      route: "/bookinganalytics",
      value: "bookinganalytics",
      category: "booking",
      description: "In-depth booking analytics",
    },
    "View Peak Season": {
      title: "Booking Configuration",
      image: peakseasonicon,
      route: "/peakseason",
      value: "peakseason",
      category: "booking",
      description: "Configure peak season settings",
    },
    "Wheel Alignment Dashboard": {
      title: "Wheel Alignment Dashboard",
      image: wheelalignment,
      route: "/wheelalignmentdashboard",
      value: "wheelalignmentdashboard",
      category: "fleet",
      description: "Wheel alignment monitoring",
    },

    // ===== BACKEND CATEGORY (8) =====
    "View All Fuel Logs": {
      title: "Fuel Management",
      image: fuelmanagement,
      route: "/fuelmanagement",
      value: "fuelmanagement",
      category: "fleet",
      description: "Monitor fuel consumption and logs",
    },
    "View All Petty Cash": {
      title: "Petty Cash",
      image: pettycash,
      route: "/pettycash",
      value: "pettycash",
      category: "fleet",
      description: "Manage and track petty cash expenses",
    },
    "Petty Cash Dashboard": {
      title: "Petty Cash Dashboard",
      image: pettycashdistribution,
      route: "/pettycashdashboard",
      value: "pettycashdashboard",
      category: "accounts",
      description: "Petty cash distribution tracking",
    },
    "View All Workorder": {
      title: "Work Order",
      image: workorders,
      route: "/workorder",
      value: "workorder",
      category: "fleet",
      description: "Manage work orders",
    },
    "View all Issues": {
      title: "View all Issues",
      image: issuesdashboard,
      route: "/viewallissues",
      value: "viewallissues",
      category: "fleet",
      description: "Track and resolve issues",
    },
    "Assign Pickup And Delivery Agent": {
      title: "Delivery & Pickups Agent Dashboard",
      image: fleetsdashboard,
      route: "/deliverypickupsagentdashboard",
      value: "deliverypickupsagentdashboard",
      category: "fleet",
      description: "Manage delivery and pickup agents",
    },
    "Partner With US": {
      title: "Partner With Us",
      image: partnerwithus,
      route: "/partnerwithus",
      value: "partnerwithus",
      category: "sales",
      description: "Partner registration and management",
    },
    "View All Subscription Inquiry": {
      title: "Subscription Dashboard",
      image: subscription,
      route: "/subscriptiondashboard",
      value: "subscriptiondashboard",
      category: "sales",
      description: "Manage subscription inquiries",
    },

    // ===== OTHER CATEGORY (2) =====
    "View All Customer": {
      title: "Customer Management",
      image: feedbacks,
      route: "/customermanagement",
      value: "customermanagement",
      category: "others",
      description: "Manage customer relationships",
    },
    "View Reports Dashboard": {
      title: "Reports",
      image: reports,
      route: "/reports",
      value: "reports",
      category: "others",
      description: "Generate and view reports",
    },
  };

  const actionToModuleDirectMap = Object.keys(moduleCardConfig).reduce(
    (acc, moduleName) => {
      const normalized = moduleName.toLowerCase();
      acc[normalized] = moduleCardConfig[moduleName].value;
      return acc;
    },
    {},
  );

  const getModuleValueFromActionName = (actionName) => {
    if (!actionName) return null;

    const normalized = actionName.toLowerCase().trim();

    return actionToModuleDirectMap[normalized] || null;
  };

  const getDashboardAccess = () => {
    const privilegedRoles = [
      rolesFromCatalogValues?.superAdmin,
      rolesFromCatalogValues?.tenantAdmin,
      rolesFromCatalogValues?.admin,
      // rolesFromCatalogValues?.franchiseAdmin,
    ].filter(Boolean);

    const userRoles = (rolesFromResponse || []).map(String);
    const hasFullAccess = userRoles.some((roleId) =>
      privilegedRoles.includes(roleId),
    );

    let allowedModules;

    if (hasFullAccess) {
      allowedModules = Object.values(moduleCardConfig);
    } else if (userRoles.includes(rolesFromCatalogValues?.franchiseAdmin)) {
      const actionNames = (actionFromResponse || []).map(
        (actionKey) => actions?.[actionKey],
      );

      const uniqueActions = [...new Set(actionNames)];

      const matchedModuleValues = uniqueActions
        .map(getModuleValueFromActionName)
        .filter(Boolean);

      allowedModules = matchedModuleValues
        .map((value) =>
          Object.values(moduleCardConfig).find((m) => m.value === value),
        )
        .filter(Boolean);
    } else {
      // normal users
      const actionNames = (actionFromResponse || []).map(
        (actionKey) => actions?.[actionKey],
      );

      // unique action labels
      const uniqueActions = [...new Set(actionNames)];

      // convert action label -> module.value
      const matchedModuleValues = uniqueActions
        .map(getModuleValueFromActionName)
        .filter(Boolean);

      // convert module.value -> moduleCardConfig object (correct!)
      allowedModules = matchedModuleValues
        .map((value) =>
          Object.values(moduleCardConfig).find((m) => m.value === value),
        )
        .filter(Boolean);
    }

    setFilteredModules(allowedModules);
  };

  useEffect(() => {
    getDashboardAccess();
  }, []);

  const drawerContent = (
    <div>
      <Toolbar />
      <Box
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          pt: 3,
          height: "100%", // or a fixed value like "calc(100vh - 64px)" depending on your layout
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#b8c6dc",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#93a8c9",
          },
        }}
      >
        <List
          sx={{
            px: 1,
            background: "linear-gradient(to bottom, #e8f0fb, #e8f0fb, #e8f0fb)",
          }}
        >
          {navItems.map((item, index) => {
            const isActive = activeItem === item.label;
            return (
              <>
                <ListItem
                  button
                  key={index}
                  selected={isActive}
                  onClick={() => {
                    window.history.replaceState(
                      {},
                      "",
                      window.location.pathname,
                    );
                    setActiveItem(item.label);
                    localStorage.setItem("status", item?.value);
                    setMobileOpen(false);
                  }}
                  className={`cursor-pointer rounded-xl mb-1.5 px-3 py-2.5 transition-all duration-300 ease-out relative overflow-hidden group ${
                    isActive
                      ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/30"
                      : "bg-white/60 hover:bg-[#d4dfed] text-slate-700 hover:translate-x-1"
                  }`}
                >
                  {isActive && (
                    <span className="absolute left-0 top-0 h-full w-1 bg-white/80 rounded-r" />
                  )}

                  <ListItemIcon
                    className={`min-w-0 mr-3 transition-transform duration-300 ${
                      isActive ? "scale-110" : "group-hover:scale-105"
                    }`}
                  >
                    {item.icon && (
                      <item.icon
                        className={`w-4 h-4 ${
                          isActive ? "text-white" : "text-slate-500"
                        }`}
                      />
                    )}
                  </ListItemIcon>

                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      className: `text-sm ${
                        isActive ? "font-semibold" : "font-medium"
                      }`,
                    }}
                  />

                  {/* Active Badge */}
                  {isActive && (
                    <span className="ml-auto rounded-full bg-white/20 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white border border-white/30">
                      Active
                    </span>
                  )}
                </ListItem>
              </>
            );
          })}
        </List>

        <div className="my-8 px-1">
          <div
            onClick={() => setOpenQuickLinks(!openQuickLinks)}
            className="cursor-pointer w-full flex items-center justify-between gap-2 px-3 py-2 text-base font-semibold text-slate-700 rounded-lg hover:bg-[#eaf0f9] transition-colors duration-200"
          >
            <span className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
              Dashboard Quick Links
            </span>
            <ChevronRight
              size={18}
              className={`transition-transform duration-300 ${
                openQuickLinks ? "rotate-90" : "rotate-0"
              }`}
            />
          </div>

          <div
            className={`overflow-hidden transition-all duration-300 ease-in-out ${
              openQuickLinks ? "opacity-100 mt-3" : "opacity-0"
            }`}
          >
            <List className="overflow-y-auto hide-scrollbar pr-1">
              {filteredModules.map((item, index) => {
                const isActive = activeItem === item.label;
                return (
                  <ListItem
                    button
                    key={index}
                    selected={isActive}
                    onClick={() => navigate(item?.route)}
                    className={`cursor-pointer rounded-lg mb-1.5 px-2.5 py-2 transition-all duration-200 ${
                      isActive
                        ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-md shadow-blue-500/20"
                        : "bg-white/60 hover:bg-[#d4dfed] hover:pl-3.5"
                    }`}
                  >
                    <ListItemIcon className="min-w-0 mr-2.5">
                      <img
                        src={item?.image}
                        className={`w-6 h-6 rounded-md object-cover ${
                          !isActive && "opacity-80"
                        }`}
                      />
                    </ListItemIcon>
                    <ListItemText
                      className="truncate"
                      primary={item.title}
                      primaryTypographyProps={{
                        className: `text-sm ${isActive ? "font-semibold" : "font-normal"}`,
                      }}
                    />
                  </ListItem>
                );
              })}
            </List>
          </div>
        </div>
      </Box>
    </div>
  );

  if (!isOnline) {
    return (
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255,255,255,0.98)",
        }}
      >
        <NoInternet />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background:
            "linear-gradient(135deg, rgba(17,24,39,0.95), rgba(30,41,59,0.92))",
          backdropFilter: "blur(18px)",
          WebkitBackdropFilter: "blur(18px)",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          borderBottomLeftRadius: "18px",
          borderBottomRightRadius: "18px",
          boxShadow: "0 12px 30px rgba(15,23,42,0.18)",
          px: 2,
        }}
      >
        <Toolbar
          sx={{
            minHeight: "72px !important",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* Left */}
          <div className="flex items-center gap-4">
            <IconButton
              onClick={handleDrawerToggle}
              sx={{
                width: 46,
                height: 46,
                color: "#fff",
                border: "1px solid rgba(255,255,255,.12)",
                background: "rgba(255,255,255,.08)",
                transition: ".3s",
                "&:hover": {
                  background: "rgba(255,255,255,.18)",
                  transform: "rotate(90deg)",
                },
              }}
            >
              <MenuIcon />
            </IconButton>

            <div
              onClick={() => navigate("/dashboard")}
              className="flex items-center gap-3 cursor-pointer select-none transition-transform hover:scale-105"
              title="Go to Dashboard"
            >
              <img
                src="https://wowcarz-file-upload.s3.ap-south-1.amazonaws.com/undefined/images-1694673789495-wowcarzlogo.png"
                alt="Wowcarz"
                className="h-11 object-contain"
              />
            </div>
          </div>

          {/* Right */}
          <div className="flex items-center gap-3">
            {/* Version Badge */}
            <div
              className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full shadow-sm transition-all duration-500 ease-out ${
                isOnline ? "bg-emerald-500 text-white" : "bg-red-500 text-white"
              }`}
            >
              <span
                className={`w-1.5 h-1.5 rounded-full bg-white ${
                  isOnline ? "" : "animate-pulse"
                }`}
              />
              <span className="text-xs font-medium">
                {isOnline ? "Online" : "Offline"}
              </span>
            </div>

            <Box
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                px: 2,
                py: 0.8,
                borderRadius: "999px",
                background: "rgba(255,255,255,.08)",
                border: "1px solid rgba(255,255,255,.08)",
                color: "#fff",
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              v{packageJson?.version}
            </Box>

              {/* User Card with Dropdown Trigger */}
              <Box
                onClick={handleProfileMenuClick}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  px: 1,
                  py: 0.6,
                  borderRadius: "999px",
                  background: "rgba(255,255,255,.08)",
                  border: "1px solid rgba(255,255,255,.08)",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    background: "rgba(255,255,255,.16)",
                    borderColor: "rgba(255,255,255,.2)",
                  },
                }}
              >
                <Avatar
                  sx={{
                    width: 30,
                    height: 30,
                    fontWeight: 700,
                    background: "linear-gradient(135deg,#6366F1,#8B5CF6,#EC4899)",
                    boxShadow: "0 6px 18px rgba(99,102,241,.45)",
                  }}
                >
                  {profile?.name?.charAt(0)?.toUpperCase()}
                </Avatar>

                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 14,
                      lineHeight: 1.2,
                    }}
                  >
                    {profile?.name}
                  </Typography>
                </Box>
              </Box>

              {/* Profile Dropdown Menu */}
              <Menu
                anchorEl={anchorEl}
                open={isProfileMenuOpen}
                onClose={handleProfileMenuClose}
                PaperProps={{
                  elevation: 4,
                  sx: {
                    mt: 1.5,
                    minWidth: 180,
                    borderRadius: "12px",
                    overflow: "visible",
                    "& .MuiMenuItem-root": {
                      fontSize: 14,
                      py: 1,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    handleProfileMenuClose();
                    navigate("/profile");
                  }}
                >
                  <PersonOutlineIcon className="mr-2" fontSize="small" /> My Profile
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleProfileMenuClose();
                    navigate("/changepassword");
                  }}
                >
                  <LockIcon className="mr-2" fontSize="small" /> Change Password
                </MenuItem>

                <Divider sx={{ my: 0.5 }} />

                <MenuItem
                  onClick={() => {
                    handleProfileMenuClose();
                    handleLogout();
                  }}
                >
                  <LogoutIcon className="mr-2" fontSize="small" /> Sign Out
                </MenuItem>
              </Menu>
          </div>
        </Toolbar>
      </AppBar>

      {/* Temporary Drawer for Mobile */}
      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
              color: "black",
            },
          }}
        >
          {isOnline ? drawerContent : <NoInternet isOnline={isOnline} />}
        </Drawer>
      )}

      {/* Permanent Drawer for Desktop */}
      {!isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiBackdrop-root": {
              backdropFilter: "blur(4px)",
              backgroundColor: "rgba(0,0,0,0.25)",
            },

            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              height: "100vh",

              // Background
              background:
                "linear-gradient(180deg, #ffffff 0%, #f8fbff 45%, #e8f0fb 100%)",

              // Glass effect
              backdropFilter: "blur(12px)",

              // Rounded only on right side
              borderTopRightRadius: 20,
              borderBottomRightRadius: 20,

              // Remove default border
              borderRight: "none",

              // Premium shadow
              boxShadow: "8px 0 30px rgba(0,0,0,0.12)",

              // Padding
              px: 2,
              py: 3,

              overflowY: "auto",

              // Hide Scrollbar
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },

              // Optional border
              border: "1px solid rgba(255,255,255,0.6)",
            },
          }}
        >
          {isOnline && drawerContent}
        </Drawer>
      )}
    </Box>
  );
};

export default Layout;
